import { render, staticRenderFns } from "./goodsLabelLifes.vue?vue&type=template&id=09bbc6b9&scoped=true&"
import script from "./goodsLabelLifes.vue?vue&type=script&lang=js&"
export * from "./goodsLabelLifes.vue?vue&type=script&lang=js&"
import style0 from "./goodsLabelLifes.vue?vue&type=style&index=0&id=09bbc6b9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bbc6b9",
  null
  
)

component.options.__file = "goodsLabelLifes.vue"
export default component.exports